<nav
  class="modern-sidenav"
  [class.collapsed]="getIsCollapsed()"
  [class.mobile-open]="isMobile"
  [class.sidenav-loading]="(state$ | async)?.isLoading"
  role="navigation"
  [attr.aria-label]="'SIDENAV.MAIN_NAVIGATION' | fallbackTranslate"
  [attr.aria-expanded]="!getIsCollapsed()"
  *ngIf="userType === 'MM' && isUsrLoggedIn() && !shouldDisableSidenav"
>
  <!-- Header Section -->
  <header class="sidenav-header">
    <div class="brand-container">
      <div class="brand-logo">
        <img
          [src]="isHqUser ? hqLogo : restaurantDetails?.logo"
          [alt]="restaurant_name + ' logo'"
          loading="lazy"
          (error)="_utilService.handleImageError($event, images.RESTAURANT)"
        />
      </div>

      <div class="brand-info" *ngIf="!getIsCollapsed()">
        <h1 class="brand-title" [title]="restaurant_name">
          {{ restaurant_name }}
        </h1>
      </div>
    </div>

    <!-- Collapsed State HQ/POS Switch Button - Below Logo -->
    <div
      class="collapsed-header-actions"
      *ngIf="getIsCollapsed() && isAdminUser"
    >
      <button
        class="collapsed-switch-btn"
        [class.switch-to-pos]="_hqService.isHqUser()"
        type="button"
        (click)="onSwitchToggle()"
        [attr.title]="
          _hqService.isHqUser()
            ? ('SIDENAV.SWITCH_TO_POS' | fallbackTranslate)
            : ('SIDENAV.SWITCH_TO_HQ' | fallbackTranslate)
        "
      >
        <span nz-icon nzType="swap" nzTheme="outline"></span>
      </button>
    </div>
  </header>

  <!-- Switch Section (HQ/POS) -->
  <section class="switch-section" *ngIf="isAdminUser">
    <button
      class="switch-pos-hq"
      [class.switch-to-pos]="_hqService.isHqUser()"
      type="button"
      (click)="onSwitchToggle()"
    >
      <span nz-icon nzType="swap" nzTheme="outline"></span>
      <span>{{
        _hqService.isHqUser()
          ? ('SIDENAV.SWITCH_TO_POS' | fallbackTranslate)
          : ('SIDENAV.SWITCH_TO_HQ' | fallbackTranslate)
      }}</span>
    </button>
  </section>

  <!-- Navigation Content -->
  <main class="nav-content" role="main">
    <div class="sidenav-groups">
      <!-- Loading State -->
      <div *ngIf="(state$ | async)?.isLoading" class="loading-placeholder">
        <nz-skeleton
          [nzActive]="true"
          [nzParagraph]="{ rows: 6 }"
          [nzTitle]="false"
        ></nz-skeleton>
      </div>

      <!-- Navigation Groups -->
      <ng-container *ngIf="!(state$ | async)?.isLoading">
        <div
          *ngFor="let group of filteredGroups$ | async; trackBy: trackGroupById"
          class="sidenav-group"
          [attr.data-group-id]="group?.id"
        >
          <!-- Group Header -->
          <div
            class="group-header"
            [class.has-active-item]="group?.hasActiveItem"
            [attr.data-group-id]="group?.id"
            (click)="
              group?.isCollapsible &&
                onGroupToggle({ event: 'group-toggle', group: group })
            "
            [attr.role]="group?.isCollapsible ? 'button' : null"
            [attr.aria-expanded]="
              group?.isCollapsible ? group?.isExpanded : null
            "
            [attr.aria-controls]="
              group?.isCollapsible ? 'group-content-' + group?.id : null
            "
            [style.cursor]="group?.isCollapsible ? 'pointer' : 'default'"
          >
            <div class="group-header-content">
              <div class="group-header-left">
                <div class="group-icon flex-align-center" *ngIf="group?.icon">
                  <img
                    [src]="getGroupIcon(group)"
                    [alt]="(group?.label | fallbackTranslate) + ' icon'"
                    loading="lazy"
                  />
                </div>

                <div class="group-header-text" *ngIf="!getIsCollapsed()">
                  <div class="group-title-container">
                    <h2 class="group-title">
                      {{ group?.label | fallbackTranslate }}
                    </h2>
                    <div
                      class="group-children-count br-50 color-white fs-10 fw-600 flex-center"
                      *ngIf="getGroupNotificationCount(group) > 0"
                      [attr.aria-label]="
                        ('SIDENAV.NOTIFICATION_COUNT' | fallbackTranslate) +
                        ': ' +
                        getGroupNotificationCount(group)
                      "
                    >
                      {{ getGroupNotificationCount(group) }}
                    </div>
                  </div>
                  <p class="group-subtitle" *ngIf="group?.description">
                    {{ group?.description | fallbackTranslate }}
                  </p>
                </div>
              </div>

              <div
                class="group-toggle"
                *ngIf="group?.isCollapsible && !getIsCollapsed()"
                [class.expanded]="group?.isExpanded"
                [class.rotated]="group?.isExpanded"
                aria-hidden="true"
              >
              <img [src]="group?.hasActiveItem ? images?.ARROW_DOWN_ACTIVE : images?.ARROW_DOWN" alt="Arrow Down" class="dropdown-arrow" *ngIf="!isHqUser"/>
              <img [src]="images?.ARROW_DOWN" alt="Arrow Down" class="dropdown-arrow" *ngIf="isHqUser"/>
              </div>
            </div>
          </div>

          <!-- Group Content -->
          <div
            class="group-content"
            [id]="'group-content-' + group?.id"
            [class.collapsed]="group?.isCollapsible && !group?.isExpanded"
            [class.expanded]="!group?.isCollapsible || group?.isExpanded"
            [attr.aria-hidden]="group?.isCollapsible && !group?.isExpanded"
          >
            <ul class="group-items" role="list">
              <li
                *ngFor="let item of group?.items; trackBy: trackItemById"
                class="sidenav-item"
                role="listitem"
              >
                <a
                  class="item-link"
                  [class.active]="isItemActive(item, currentUrl)"
                  [class.locked]="item?.isLocked "
                  [routerLink]="item?.route"
                  [attr.aria-label]="
                    (item?.label | fallbackTranslate) +
                    (item?.description
                      ? ': ' + (item?.description | fallbackTranslate)
                      : '')
                  "
                  [attr.aria-current]="
                    isItemActive(item, currentUrl) ? 'page' : null
                  "
                  [attr.title]="
                    getIsCollapsed() ? (item?.label | fallbackTranslate) : null
                  "
                  (click)="
                    onItemClick({
                      event: 'item-click',
                      item: item,
                      nativeEvent: $event
                    })
                  "
                  role="menuitem"
                >
                  <!-- Item Icon -->
                  <span class="item-icon" *ngIf="item?.icon" aria-hidden="true">
                    <nz-badge
                      *ngIf="getIsCollapsed()"
                      [nzCount]="getItemNotificationCount(item)"
                      [nzOverflowCount]="99"
                      nzSize="small"
                    >
                      <img
                        [src]="getItemIcon(item)"
                        [alt]="item?.label + ' icon'"
                      />
                    </nz-badge>
                    <img
                      *ngIf="!getIsCollapsed()"
                      [src]="getItemIcon(item)"
                      [alt]="item?.label + ' icon'"
                    />
                  </span>

                  <!-- Item Content -->
                  <div class="item-content" *ngIf="!getIsCollapsed()">
                    <h3 class="item-label"
                    [class.activeItem]="isItemActive(item, currentUrl)"
                    [class.hq-active-item]="isHqUser && isItemActive(item, currentUrl)"
                    >
                      {{ item?.label | fallbackTranslate }}
                    </h3>
                    <p class="item-description" *ngIf="item?.description">
                      {{ item?.description | fallbackTranslate }}
                    </p>
                  </div>

                  <!-- Item Badge/Notifications -->
                  <div class="item-badge" *ngIf="!getIsCollapsed()">
                    <!-- Notification Badge -->
                    <nz-badge
                      [nzCount]="getItemNotificationCount(item)"
                      [nzOverflowCount]="99"
                      class="notification-badge"
                    ></nz-badge>

                    <!-- Status Indicator -->
                    <span
                      class="status-indicator"
                      *ngIf="item?.hasStatusIndicator"
                      [attr.aria-label]="
                        ('SIDENAV.STATUS' | fallbackTranslate) +
                        ': ' +
                        (item?.status ||
                          ('SIDENAV.STATUS_ACTIVE' | fallbackTranslate))
                      "
                    ></span>

                    <!-- Lock Icon -->
                    <span
                      *ngIf="item?.isLocked"
                      nz-icon
                      nzType="lock"
                      nzTheme="fill"
                      class="lock-icon"
                      [attr.aria-label]="
                        'SIDENAV.FEATURE_LOCKED' | fallbackTranslate
                      "
                    ></span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="collapsed-line-break m-b-24" *ngIf="!isMobile && getIsCollapsed()"></div>
        <button
        *ngIf="!isMobile && getIsCollapsed()"
        class="fmh-switch-btn-collapsed m-b-4"
        [style.background-image]="'url(' + images?.FMH_BACKGROUND + ')'"
        type="button"
        (click)="onSwitchToFMH()"
        [attr.aria-label]="'SIDENAV.SWITCH_TO_FMH' | fallbackTranslate"
      >
        <img [src]="images.SIDENAV_FMH_LOGO" [alt]="'FMH Logo'" class="collapsed-fmh-logo" />
      </button>
      </ng-container>

      <!-- Empty State -->
      <div
        class="empty-state"
        *ngIf="
          (filteredGroups$ | async)?.length === 0 &&
          !(state$ | async)?.isLoading
        "
        role="status"
        aria-live="polite"
      >
        <span
          nz-icon
          nzType="inbox"
          nzTheme="outline"
          aria-hidden="true"
        ></span>
        <h3 class="empty-title">
          {{ 'SIDENAV.NO_NAVIGATION_ITEMS' | fallbackTranslate }}
        </h3>
        <p class="empty-description">
          {{ 'SIDENAV.NO_NAVIGATION_ITEMS_DESCRIPTION' | fallbackTranslate }}
        </p>
      </div>
    </div>
  </main>

  <!-- Footer Section -->
  <footer class="sidenav-footer"
  [class.no-border]="getIsCollapsed()"
  >
    <!-- Expanded State Footer -->
    <div class="footer-content h-100" *ngIf="!getIsCollapsed()">
      <div class="footer-actions h-100">
        <!-- Switch to FMH Button -->
        <button
          class="fmh-switch-btn m-b-4"
          [style.background-image]="'url(' + images?.FMH_BACKGROUND + ')'"
          type="button"
          (click)="onSwitchToFMH()"
          [attr.aria-label]="'SIDENAV.SWITCH_TO_FMH' | fallbackTranslate"
        >
          <img [src]="images.SIDENAV_FMH_LOGO" [alt]="'FMH Logo'" />
          <span class="fs-16 fw-600 clr-333">{{ 'SIDENAV.SWITCH_TO_FMH' | fallbackTranslate }}</span>
        </button>

        <!-- Action Buttons -->
        <div
          class="action-buttons"
          role="group"
          [attr.aria-label]="'SIDENAV.QUICK_ACTIONS' | fallbackTranslate"
        >
          <button
            class="action-btn logout-btn"
            type="button"
            (click)="logout()"
            [attr.aria-label]="'SIDENAV.LOG_OUT' | fallbackTranslate"
            [attr.title]="'SIDENAV.LOG_OUT' | fallbackTranslate"
            (mouseenter)="isHoveringLogout = true"
            (mouseleave)="isHoveringLogout = false"
          > 
          <div class="wd-100 ta_center">
            <img [src]="isHoveringLogout ? images?.LOGOUT_ICON_HOVER : images?.LOGOUT_ICON" [alt]="'Logout Icon'" />
            <span class="fs-14 fw-600 m-l-4">{{ 'SIDENAV.LOG_OUT' | fallbackTranslate }}</span>
          </div>
          </button>

          <button
            class="action-btn lock-btn"
            type="button"
            (click)="onLockScreen()"
            [attr.aria-label]="'SIDENAV.LOCK_SCREEN' | fallbackTranslate"
            [attr.title]="'SIDENAV.LOCK_SCREEN' | fallbackTranslate"
            (mouseenter)="isHoveringLock = true"
            (mouseleave)="isHoveringLock = false"
            *ngIf="!_hqService.isHqUser() && isLockScreenEnabled"
          >
          <div class="wd-100 ta_center flex-center">
            <img [src]="isHoveringLock ? images?.LOCK_ICON_HOVER : images?.LOCK_ICON" [alt]="'Lock Icon'" />
            <span class="m-l-4 fs-14 fw-700">{{ 'SIDENAV.LOCK_SCREEN' | fallbackTranslate }}</span>
          </div>
          </button>
        </div>
      </div>
    </div>

    <!-- Collapsed State Footer -->
    <div class="footer-content-collapsed h-100" *ngIf="getIsCollapsed()">
      <div class="collapsed-actions h-100">
        <!-- Lock Screen Button -->
        <button
          class="collapsed-action-btn lock-btn"
          type="button"
          (click)="onLockScreen()"
          [attr.title]="'SIDENAV.LOCK_SCREEN' | fallbackTranslate"
          (mouseenter)="isHoveringLock = true"
          (mouseleave)="isHoveringLock = false"
          *ngIf="!_hqService.isHqUser() && isLockScreenEnabled"
        >
        <img [src]="isHoveringLock ? images?.LOCK_ICON_HOVER : images?.LOCK_ICON" [alt]="'Lock Icon'" />
        </button>

        <!-- Logout Button -->
        <button
          class="collapsed-action-btn logout-btn"
          type="button"
          (click)="logout()"
          [attr.title]="'SIDENAV.LOG_OUT' | fallbackTranslate"
          (mouseenter)="isHoveringLogout = true"
          (mouseleave)="isHoveringLogout = false"
        >
          <img [src]="isHoveringLogout ? images?.LOGOUT_ICON_HOVER : images?.LOGOUT_ICON" [alt]="'Logout Icon'" />
        </button>
      </div>
    </div>
  </footer>

  <!-- Collapsed State Tooltips -->
  <div *ngIf="getIsCollapsed()" class="collapsed-tooltips">
    <!-- You can add nz-tooltip directives to collapsed items for better UX -->
  </div>

  <!-- Arrow Icon at Top Right Corner -->
  <div
    class="arrow-toggle"
    (click)="onCollapseToggleClick()"
    [attr.aria-label]="
      getIsCollapsed()
        ? ('SIDENAV.EXPAND_NAVIGATION' | fallbackTranslate)
        : ('SIDENAV.COLLAPSE_NAVIGATION' | fallbackTranslate)
    "
    role="button"
    tabindex="0"
    (keydown.enter)="onCollapseToggleClick()"
    (keydown.space)="onCollapseToggleClick()"
  >
    <img [src]="getIsCollapsed() ? images?.ARROW_RIGHT : images?.ARROW_LEFT" [alt]="'Arrow Icon'" />
  </div>
</nav>
